module.exports = "<p>\r\n  solicitar-permisos works!\r\n</p>\r\n"